import * as yup from 'yup';

import textContent from '../../../../utils/textContent.json';

export const addBannerValidation = yup.object({
  title: yup.string().max(28, textContent.banners.validations.titleMax).required(),
  desktopImage: yup.string().required(),
  mobileImage: yup.string().required(),
});
